import {Observable} from "rxjs";
import {DeepLink} from "@app/core/shared/domain/entities/deep-link";


export abstract class PushNotificationsService {
    /**
     * Emits the deep link when the user clicks on a push notification with a configured deep link.
     * @returns {Observable<DeepLink>} An observable that emits the deep link.
     */
    abstract getDeepLink(): Observable<DeepLink>;
}
